import { render, staticRenderFns } from "./add-list.vue?vue&type=template&id=6f176e80&"
import script from "./add-list.vue?vue&type=script&lang=ts&"
export * from "./add-list.vue?vue&type=script&lang=ts&"
import style0 from "./add-list.vue?vue&type=style&index=0&id=6f176e80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports